var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_c('v-container', [_c('m-header', {
    attrs: {
      "title": "Kundendaten",
      "subtitle": _vm.subtitle,
      "breadCrumbs": _vm.breadCrumbs
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('analytics-date-range-selector-dialog', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "dates": _vm.dates
          },
          on: {
            "setDate": _vm.loadDataForDateRange
          }
        })];
      },
      proxy: true
    }])
  }), _c('thg-analytics-customer-data-table-card', {
    attrs: {
      "hasPem": true,
      "isLoading": _vm.dataHandler.thgCustomerData.isLoading,
      "customerData": _vm.thgCustomerData
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }